import { useEffect } from 'react';

export const useChangeBodyBackgroundColor = (color: string): void => {
  useEffect(() => {
    const currentColor = document.body.style.backgroundColor;
    document.body.style.backgroundColor = color;

    return (): void => {
      document.body.style.backgroundColor = currentColor;
    };
  }, [color]);
};
